import { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';

import { GlobalContext } from '../../../GlobalContext';
import Checkbox from '../../../components/Checkbox/Checkbox';
import { IconAiStars } from '../../../icons';
import RoutesEnum from '../../../core/enums/RoutesEnum';

interface iGlobalSearchHeaderProps {
    setQueryValue: (value: string) => void;
    setSearchInputValue: (value: string) => void;
    searchInputValue: string;
    isAiSearchEnabled: boolean;
    onAiSearch: () => void;
    onSimpleSearch: () => void;
}

const GlobalSearchHeader = ({
    setQueryValue,
    setSearchInputValue,
    searchInputValue,
    isAiSearchEnabled,
    onAiSearch,
    onSimpleSearch
}: iGlobalSearchHeaderProps) => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Enter') {
                setQueryValue(searchInputValue);
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [searchInputValue, setQueryValue]);

    useEffect(() => {
        setSearchInputValue(searchInputValue);
    }, [searchInputValue, setSearchInputValue]);

    const { inMyLibrary, setInMyLibrary } = useContext(GlobalContext);

    return (
        <div className="GlobalSearch__header">
            <div className="GlobalSearch__header-text">
                {isAiSearchEnabled && (
                    <>
                        <IconAiStars /> <strong>Ask a question&nbsp;</strong> or&nbsp;
                    </>
                )}
                {`${isAiSearchEnabled ? 'just' : 'Just'}`} type in any food, flavor, or beverage to get started. Want
                <strong className="is-news">&nbsp;News</strong>?&nbsp;
                <Link to={RoutesEnum.News} className="GlobalSearch__news-link">
                    Click here
                </Link>
                .
            </div>

            <div className="GlobalSearch__input-container">
                <input
                    className="GlobalSearch__input"
                    autoFocus
                    value={searchInputValue}
                    onChange={(event) => setSearchInputValue(event.target.value)}
                />

                <button
                    className={cn('GlobalSearch__ai-search-btn', {
                        'is-disabled': !isAiSearchEnabled
                    })}
                    onClick={onAiSearch}
                    disabled={!isAiSearchEnabled}
                    type="button"
                >
                    <IconAiStars className="GlobalSearch__ai-search-btn-icon" />
                    AI search
                </button>
            </div>

            <div className="GlobalSearch__header-bottom">
                <div className="GlobalSearch__toggle">
                    <Checkbox
                        color="white"
                        isChecked={inMyLibrary}
                        label="In my library"
                        onChange={() => setInMyLibrary(!inMyLibrary)}
                        isToggle
                    />
                </div>

                <button className="GlobalSearch__simple-search-btn" onClick={onSimpleSearch} type="button">
                    simple search
                </button>
            </div>
        </div>
    );
};

export default GlobalSearchHeader;
